import { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import Button from '@rio-cloud/rio-uikit/Button';
import Dialog from '@rio-cloud/rio-uikit/Dialog';
import { OPEN_DIALOG_EVENT } from '@rio-cloud/rio-uikit/FrameDialog';
import usePostMessageSender from '@rio-cloud/rio-uikit/usePostMessageSender';

import { buildMfeDialogUrl } from '@/config';
import { DEFAULT_LOCALE } from '@/configuration/lang/lang';
import { getLocale } from '@/configuration/lang/langSlice';
import { AnalyticsUtils } from '@/configuration/setup/googleAnalytics';
import { useAppSelector } from '@/configuration/setup/hooks';
import { getAccessToken } from '@/configuration/tokenHandling/tokenSlice';

const BATTERY_SERVICE_DIALOGS = 'BATTERY-SERVICE-DIALOGS';

const PackDetailsButton = ({ assetId }: { assetId: string }) => {
    const { sendMessageToParent } = usePostMessageSender();
    const token = useAppSelector(getAccessToken);
    const locale = useAppSelector(getLocale) || DEFAULT_LOCALE;

    const handleOpenPackDetailsDialog = useCallback(() => {
        sendMessageToParent({
            type: `${BATTERY_SERVICE_DIALOGS}${OPEN_DIALOG_EVENT}`,
            payload: {
                src: buildMfeDialogUrl(`/dialog/pack-levels/${assetId}`, locale, token),
                dialogProps: {
                    bsSize: Dialog.SIZE_MD,
                },
            },
        });
        AnalyticsUtils.gaPush({
            event: 'button_pack_details',
            parameters: {
                element_name: 'PackDetailsButton',
                component_name: 'Button',
                flow_name: 'view_workshop_battery_health_data',
                trigger: 'click',
            },
            userProps: {},
        });
    }, [sendMessageToParent, assetId, locale, token]);

    return (
        <div className="display-flex justify-content-end">
            <Button type="button" onClick={handleOpenPackDetailsDialog}>
                <FormattedMessage id="intl-msg:batteryService.batteryPackLevel.details" />
            </Button>
        </div>
    );
};

export default PackDetailsButton;
